{
  "admin": {
    "fast-forward": "Превъртане напред",
    "no-segment-pause": "Не спирай на сегментите на видеото",
    "show-correct-answers": "Покажи верните отговори",
    "title": "Тестов режим",
    "transfer-to-new-device": "Прехвърляне на друго устройство",
    "video-stats": "Видео статистика"
  },
  "android-app": {
    "download-button": "Изтеглете от Google Play",
    "footer-note": "Не намирате къде да въведете кода? След отваряне на приложението ще видите екран \"Вход за служители\".",
    "heading": "Инсталирайте приложението и влезте с Вашия код",
    "how-to-start": "Как да започнете:",
    "intro": "Какво получавате:",
    "notifications-desc": "Получавайте известия в реално време, без да е необходимо да проверявате приложението ръчно.",
    "notifications-title": "Директни известия (Push Notifications)",
    "scanner-desc": "Интелигентната камера автоматично разпознава границите на документа, коригира перспективата и оптимизира осветеността за по-добра четивност на текста.",
    "scanner-title": "Усъвършенстван скенер за документи",
    "step1": "Свалете приложението:",
    "step2": "Отворете го",
    "step3": "Въведете следния код:",
    "title": "Приложение за Андроид"
  },
  "broadcast": {
    "from": "Изпратено от <Name/> на <SentAt/>",
    "mark-as-read": "Прочетено",
    "mark-as-read-confirm": {
      "title": "Подпишете се за да потвърдите, че сте прочели и разбрали това съобщение"
    },
    "read-at": "Прочетено от <Name/> на <ReadAt/>"
  },
  "control-card": {
    "action": {
      "complete": "Приключи контролната карта",
      "print": "Печат",
      "signature": "Подпис",
      "title": "Действия за тази контролна карта",
      "uncomplete": "Отключи контролната карта",
      "view-print": "Покажи / Печат"
    },
    "add-new-record-title": "{{title}}: добавяне на нов запис",
    "breadcrumbs": {
      "row": "Запис {{current}} от {{total}}"
    },
    "comment": "Коментар",
    "complete-alert": {
      "confirm": "Попълни",
      "message": "За да приключите контролната карта, трябва да попълните всички записи.",
      "title_one": "Има един запис, който не е попълнен",
      "title_other": "Има {{count}} записа, който не са попълнени"
    },
    "complete-error": {
      "message_one": "Има един запис, който не е попълнен",
      "message_other": "Има {{count}} записа, които не са попълнени",
      "title": "Контролната карта не може да бъде приключена"
    },
    "due-to": "краен срок: <Time/><RelTime/>",
    "error": {
      "saving-error": "Възникна грешка при запазване на данните: {{message}}. За да опитате отново, натиснете бутонът \"Запази\""
    },
    "instantiate": {
      "confirmation-message": "Сигурни ли сте че искате да създадете контролна карта \"{{name}}\"?",
      "header": "Нова контролна карта \"{{name}}\"",
      "message": "Трябва да изберете една от следните възможности:",
      "option-create-copy": "Прехвърляне на данните от тази контролна карта",
      "option-create-empty": "Нова празна контролна карта"
    },
    "location": {
      "archived-title": "Архивирани контролни карти",
      "create-new": "Създай",
      "date": "За дата",
      "edit-disabled-banner": "Картата не може да бъде редактирана поради изтекъл срок или липса на права за попълване",
      "label": "Обект",
      "no-control-cards": "Няма намерени контролни карти",
      "not-applicable": {
        "header": "Неприложима",
        "message": "Тази контролна карта е отбелязана от {{notApplicableBy}} като неприложима с причина: {{notApplicableReason}}"
      },
      "recurring": {
        "create": {
          "date": "За дата",
          "no-permission": "Нямате права за създаването на контролни карти за тази дата",
          "template": "Изберете новата карта",
          "title": "Нова периодична контролна карта"
        },
        "filter": {
          "endDate": "До дата",
          "label": "Филтър",
          "startDate": "От дата",
          "status": "Статус",
          "statuses": {
            "all": "Приключени и не приключени",
            "complete": "Само приключени",
            "incomplete": "Само не приключени"
          },
          "subtitle": "Филтриране на контролните карти по следните критерии:",
          "template": "Вид",
          "text": "Име",
          "textPlaceholder": "Без значение",
          "title": "Филтриране на контролните карти"
        },
        "load-more": "Зареди по-стари от <StartDate/>"
      },
      "title": "Контролни карти за попълване"
    },
    "nested": {
      "create": "Създай",
      "creating": "Създаване...",
      "open": "Отвори",
      "status": {
        "completed": "Приключена",
        "not-applicable": "Неприложима",
        "pending": "Незавършена"
      }
    },
    "no-locations": "Нямате достъп до контролните карти на нито един обект",
    "number-range": {
      "max-exceeded": "Максимално допустимата стойност е {{maxValue}}",
      "min-exceeded": "Минимално допустимата стойност е {{minValue}}",
      "no-unit": {
        "closed": "{{start}} – {{end}}",
        "open-end": "над {{start}}",
        "open-start": "под {{end}}"
      },
      "text": "Диапазон",
      "unit": {
        "closed": "{{start}} – {{end}} {{unit}}",
        "open-end": "над {{start}} {{unit}}",
        "open-start": "под {{end}} {{unit}}"
      }
    },
    "override-validation-result": {
      "mark-not-applicable": "Отбележи като неприложимо",
      "option": {
        "not-applicable": "Неприложимо",
        "other": "Друго",
        "other-placeholder": "Напишете причина"
      },
      "reason-option-required": "Трябва да изберете една от следните опции:",
      "title": "Отбележете причина защо не можете да попълните това поле:"
    },
    "primary-column-title_one": "В тази контролна карта има един запис \"{{title}}\"",
    "primary-column-title_other": "В тази контролна карта има {{count}} записа \"{{title}}\"",
    "row": {
      "action": {
        "complete": "Приключи",
        "complete-error": {
          "message_one": "Има един запис, който не е попълнен",
          "message_other": "Има {{count}} записа, които не са попълнени",
          "title": "Контролната карта не може да бъде приключена"
        },
        "complete-success-last-record": "Контролната карта е изцяло попълнена",
        "confirm-delete": {
          "title_one": "Сигурни ли сте че искате да изтриете този запис?",
          "title_other": "Сигурни ли сте че искате да изтриете тези {{count}} записа?",
          "title-name": "Изтрий \"{{name}}\"?"
        },
        "confirm-remove-signature": {
          "title": "Сигурни ли сте че искате да премахнете този подпис?"
        },
        "delete": "Изтрий",
        "more-info": "Допълнителна информация",
        "title": "Действия за този запис",
        "uncomplete": "Отключи"
      },
      "completed-by": "Приключен от",
      "more-info": {
        "title": "Информация за този запис"
      }
    },
    "status": {
      "completed": "Попълнена от <Name/>",
      "not-applicable": "Неприложима ({{notApplicableBy}} отбеляза причина: {{notApplicableReason}})",
      "not-completed": "Не е приключена"
    },
    "title": "Контролни карти",
    "type": {
      "daily": "Ежедневни",
      "recurring": "Периодични"
    },
    "value": {
      "empty": "Няма стойност",
      "invalid": "Невалидни данни!"
    }
  },
  "error": {
    "playback": {
      "header": "Грешка при възпроизвеждане на темата",
      "message": "Моля, презаредете страницата и опитайте отново.",
      "reload-button": "Презареди"
    },
    "unexpected": {
      "header": "Грешка",
      "message": "Моля, презаредете приложението.",
      "reload-button": "Презареди"
    }
  },
  "g": {
    "action": "Действия",
    "add": "Добави",
    "all": "Всички",
    "app-name": "FSAcademy.bg",
    "attachment": {
      "delete-confirmation": {
        "title": "Сигурни ли сте, че искате да изтриете тази снимка?"
      }
    },
    "back": "Назад",
    "back-to-home": "Към началния екран",
    "cancel": "Откажи",
    "change": "Промени",
    "clear": "Изчисти",
    "close": "Затвори",
    "combo-box": {
      "add-header": "Добави опция",
      "delete-title": "Сигурни ли сте, че искате да изтриете \"{{value}}\"?",
      "edit-header": "Редактирай опцията",
      "placeholder": "Търсене в списъка"
    },
    "complete": "Приключи",
    "continue_zero": "Продължи",
    "continue_one": "Продължи ({{count}})",
    "continue_other": "Продължи ({{count}})",
    "copyright-and-privacy-policy": "© 2026 Еф Ес Академи ООД ⋅ <2>Политика за лични данни</2>",
    "delete": "Изтрий",
    "discard": "Отмени",
    "doc-file-name": "Име на файла",
    "doc-file-size": "Размер",
    "edit": "Редактирай",
    "error": {
      "action-failed": "Грешка при изпълнение на действието",
      "barsy-error": "Barsy грешка",
      "disabled-error": "Вашият акаунт е деактивиран. Моля свържете се с администратора",
      "network-error": "Временно няма връзка със сървъра. Проверете връзката си с Интернет и опитайте отново",
      "not-available-error": "Ресурсът не е наличен или нямате достъп до него.",
      "server-error": "Сървърна грешка. Моля опитайте отново след малко"
    },
    "feature-disabled": "Тази услуга не е активна за Вашата фирма",
    "filter": "Приложи филтъра",
    "filter-button_zero": "Филтър",
    "filter-button_one": "Филтър ({{count}})",
    "filter-button_other": "Филтри ({{count}})",
    "later": "По-късно",
    "loading": "Зареждане, моля изчакайте...",
    "loading-error": "Възникна грешка, моля презаредете страницата след няколко секунди",
    "ok": "OK",
    "page-not-found": "Няма такава страница",
    "pagination": {
      "page": "Страница {{pageNumber}} от {{pageCount}}"
    },
    "privacy-policy-url": "/legal/privacy-policy/latest",
    "remove": "Премахни",
    "required": "задължително",
    "save": "Запази",
    "search-employee-name-or-position": "Търсене по име или длъжност",
    "select-date": "Изберете дата",
    "select-employee": "Изберете служител",
    "select-time": "Изберете час",
    "select-value": "Изберете",
    "server-error": {
      "broadcast": {
        "not-editable": "Това съобщение не може да бъде редактирано"
      },
      "client": {
        "name-blank": "Името не трябва да е празно"
      },
      "export": {
        "cards-not-found": "Някои от избраните контролни карти не са намерени или не са достъпни",
        "filter-empty": "Няма контролни карти, отговарящи на избрания филтър",
        "filter-limit-exceeded": "Филтърът обхваща {{matched}} контролни карти — максимумът за един експорт е {{max}}",
        "limit-exceeded": "Избрани са {{selected}} контролни карти — максимумът за един експорт е {{max}}",
        "must-be-stopped": "Експортът трябва първо да бъде спрян",
        "no-cards-selected": "Няма избрани контролни карти за експорт"
      },
      "level": {
        "no-free-seats": "Няма достатъчно свободни места в избраното ниво",
        "not-empty": "В това ниво все още има {{occupied}} служители",
        "seats-below-occupied": "Текущия брой служители в нивото е {{occupied}} и не може да бъде намален до {{requested}}"
      },
      "login": {
        "invalid-credentials": "Невалидна парола"
      },
      "manager": {
        "duplicate-email": "Съществува друг потребител с този имейл"
      },
      "password": {
        "mismatch": "Паролите не съвпадат",
        "too-short": "Паролата трябва да е поне {{minLength}} символа"
      },
      "supplier": {
        "duplicate-name": "Съществува друг доставчик с това име"
      },
      "ticket": {
        "admin-recipient": "Администраторите не могат да бъдат получатели на сигнали",
        "last-recipient": "Не може да напуснете сигнал, ако сте единственият получател",
        "not-recipient": "Не сте получател на този сигнал"
      }
    },
    "share": {
      "button": "Сподели",
      "download": {
        "downloading": "Изтегляне, моля изчакайте...",
        "error": {
          "message": "Възникна грешка при изтегляне на файла. Моля опитайте отново.",
          "title": "Грешка при изтегляне на файла"
        }
      },
      "error": {
        "generic": "Вашият браузър не поддържа този начин за споделяне на файлове. Моля опитайте другите опции",
        "title": "Грешка при споделяне"
      },
      "pdf-file-attach": "Споделяне на PDF",
      "pdf-file-download": "Изтегляне на PDF",
      "title": "Споделяне на документ {{name}}"
    },
    "upload": "Качи",
    "upload-more": "Качи още",
    "uploaded-files_one": "Качени файлове: {{count}}",
    "uploaded-files_other": "Качени файлове: {{count}}",
    "uploading": "Качване ({{uploadProgress}})",
    "user-disable": {
      "action": "Влезте като друг служител",
      "title": "Вашият достъп е деактивиран"
    },
    "validation": {
      "access-code-length": "Кодът за достъп трябва да е 9 символа",
      "date-invalid": "Невалидна дата",
      "date-required": "Датата е задължителна",
      "number-invalid": "Невалидно число",
      "phone-length": "Телефонният номер трябва да бъде точно 9 цифри",
      "required": "Задължително",
      "time-invalid": "Невалиден час",
      "time-required": "Часът е задължителен"
    },
    "yes": "Да"
  },
  "help": {
    "email-action": "{{email}}",
    "email-title": "Свържете се с нас по имейл:",
    "manual-action": "Отвори ръководството",
    "manual-title": "Прегледайте ръководството за потребителя:",
    "p1": "Ако имате затруднения с използването на приложението, можете да получите помощ по следните начини:",
    "phone-action": "{{phone}}",
    "phone-title": "Свържете се с нас на телефон:",
    "title": "Помощ",
    "viber-action": "Чат във Viber",
    "viber-title": "Изпратете ни съобщение през Viber:",
    "work-hours": "Ще може да ви отговорим в работни дни, от 9 до 17 часа"
  },
  "incdoc": {
    "action": {
      "confirm-delete": {
        "title": "Сигурни ли сте че искате да изтриете този документ?"
      },
      "delete": "Изтрий",
      "edit": "Редактирай",
      "scan-result": "Виж разпознатия документ",
      "title": "Действия"
    },
    "add-doc": "Нов документ",
    "doc": {
      "add-document-success": "Успешно добавяне на документ",
      "add-document-title": "Добавяне на документ",
      "ai-apply-button": "Попълни избраните",
      "ai-create-new": "Създай нов",
      "ai-dialog-title": "Сверете разпознатите атрибути с документа",
      "ai-existing": "Съществуващ",
      "ai-fill-button": "Стартирай",
      "ai-fill-label": "Попълни с AI",
      "ai-new": "Нов",
      "ai-no-results": "Не успяхме да разпознаем данни от документите. Моля, направете по-ясна снимка — уверете се, че има достатъчно светлина и целият документ се вижда в кадъра.",
      "ai-no-results-label": "Не разпознахме данни с AI",
      "ai-suggestions-button": "Преглед",
      "ai-suggestions-label": "Разпознахме документа с AI",
      "ai-use-existing": "Използвай съществуващ",
      "doc-date": "Дата на документа",
      "doc-num": "Номер на документ",
      "doc-num-placeholder": "Въведете номерът на документа",
      "edit-document-title": "Редактиране на документ",
      "location": "Обект",
      "notes": "Бележки",
      "notes-placeholder": "Допълнителни бележки (ако има нужда)",
      "supplier": "Доставчик",
      "update-document-success": "Успешно редактиране на документ"
    },
    "doc-name": "{{number}} от {{date}}",
    "doc-no": "Документ №{{docNum}}",
    "doc-subtitle": "От дата <2><0></0></2>, доставчик <4>{{supplierName}}</4>, за обект <6>{{locationName}}</6>, създаден от <9>{{creatorName}}</9> на <11><0></0></11>",
    "filter": {
      "created-date-after": "От дата на създаване",
      "created-date-before": "До дата на създаване",
      "doc-date-after": "От дата на документа",
      "doc-date-before": "До дата на документа",
      "keyword": "Търсене",
      "keyword-placeholder": "По номер на документ, доставчик, и др.",
      "order": "Подреждане",
      "order-by": {
        "created-at": "Дата на създаване",
        "document-date": "Дата на документа"
      },
      "title": "Филтриране на документите"
    },
    "no-documents": "Няма намерени документи",
    "pagination-count": "{{itemCount}} документа",
    "purchase-doc": {
      "actions-title": "Действия",
      "export-excel": "Експорт като Excel",
      "invoice-number": "Документ № {{num}}",
      "preview-title": "Преглед на разпознаването"
    },
    "supplier": {
      "add-supplier-error": "Грешка при добавяне на доставчик",
      "add-supplier-success": "Успешно добавяне на доставчик",
      "add-title": "Добавяне на доставчик",
      "display-with-eik": "{{name}} (ЕИК {{eik}})",
      "edit-supplier-error": "Грешка при промяна на доставчик",
      "edit-supplier-success": "Успешна промяна на доставчик",
      "edit-title": "Редактиране на доставчик",
      "eik": "ЕИК",
      "eik-placeholder": "Въведете ЕИК на доставчика",
      "name": "Име",
      "name-placeholder": "Въведете името на доставчика",
      "notes": "Бележки",
      "notes-placeholder": "Допълнителни бележки (ако има нужда)"
    },
    "title": "Входящ Контрол",
    "upload": {
      "error": "Грешка при качване",
      "finished": "Прикачен",
      "pending": "В изчакване",
      "uploading": "Качва се"
    }
  },
  "login": {
    "employee-login": "Вход за служители",
    "enter-your-access-code": "Въведете Вашият код за достъп",
    "failed": "Неуспешен вход. Проверете дали сте въвели правилно кода за достъп",
    "login-button": "Вход",
    "no-access-code": "Нямам код за достъп",
    "privacy-policy": "С натискането на бутона \"Вход\" се съгласявате с <2>политиката за лични данни</2>.",
    "success": "Успешен вход!",
    "welcome": "Добре дошли в FSAcademy!"
  },
  "menu": {
    "android-app": "Приложение за Андроид",
    "control-card": "Контролни карти",
    "course": "Обучение",
    "help": "Помощ",
    "incoming-control": "Входящ контрол",
    "language": "Език",
    "logged-out": {
      "already-part-of-team": "Вече сте част от екип?",
      "contact-admin-for-code": "Свържете се с Вашия ръководител за код за достъп.",
      "contact-us-to": "Свържете се с нас, за да:",
      "email": "Имейл",
      "fully-digitize": "<0>дигитализирате изцяло</0> контрола на хранителната безопасност.",
      "get-demo": "получите <1>кратко демо</1> на платформата.",
      "get-to-know-services": "се <1>запознаете</1> с нашите дигитални услуги.",
      "phone": "Телефон",
      "want-to-digitize-question": "Искате да дигитализирате вашата хранителна безопасност?"
    },
    "logout": "Изход",
    "new-badge": "Ново",
    "notifications": "Известия",
    "organizer": "Органайзер",
    "test-mode": "Тестов режим",
    "tickets": "Сигнали"
  },
  "notifications": {
    "marked-all-as-read": "Всички известия са маркирани като прочетени",
    "native": {
      "enable-notifications": "Известия на устройството",
      "permission-hint": "За да получавате известия, трябва да дадете разрешение",
      "title": "Настройки за известия"
    },
    "no-notifications": "Нямате известия",
    "read-at": "Прочетено на <ReadAtTime/>",
    "title_zero": "Известия",
    "title_one": "Известия ({{count}})",
    "title_other": "Известия ({{count}})",
    "unread-alert": {
      "header_one": "Имате {{count}} непрочетено известие",
      "header_other": "Имате {{count}} непрочетени известия",
      "message_one": "Желаете ли да го прочетете сега?",
      "message_other": "Желаете ли да ги прочетете сега?"
    }
  },
  "organizer": {
    "action": {
      "confirm-delete": {
        "title": "Изтрий {{name}}?"
      },
      "edit": "Редактирай"
    },
    "add-document-title": "Добавяне на документ",
    "edit-document-title": "Редактиране на документ",
    "folder": {
      "add-new-document": "Нов документ",
      "add-title": "Добавяне на папка",
      "confirm-delete": {
        "message": "Всички документи в папката ще бъдат изтрити!",
        "title": "Изтрий {{name}}?"
      },
      "edit": "Редактирай",
      "edit-title": "Редактиране на папка",
      "name": "Име",
      "name-placeholder": "Въведете името на папката",
      "title": "Документи"
    },
    "folder-list": {
      "add": "Нова папка",
      "title": "Папки"
    },
    "form": {
      "folder": "Папка",
      "folder-required": "Изберете папка",
      "name": "Име",
      "name-placeholder": "Име на документа, например Разрешително за...",
      "name-required": "Името е задължително",
      "notes": "Бележки",
      "notes-placeholder": "Допълнителни бележки (ако има нужда)",
      "notify-before-expiry": "Изпрати ми напомняне",
      "notify-before-expiry-hint-1": "Ще изпратим предупреждаващо известие преди да изтече документа.",
      "notify-before-expiry-hint-2": "Изберете \"Изтича на\" за да добавите напомняне.",
      "notify-before-expiry-placeholder": "Без напомняне",
      "notify-before-expiry-unit": "дни по-рано",
      "state": "Състояние",
      "valid-from": "Дата на издаване",
      "valid-from-hint": "Не попълвайте ако няма дата на издаване",
      "valid-until": "Изтича на",
      "valid-until-hint": "Не попълвайте ако няма срок",
      "valid-until-quick-hint": "Бързи срокове",
      "valid-until-quick-hint-1-month": "1 месец",
      "valid-until-quick-hint-1-year": "1 година",
      "valid-until-quick-hint-2-years": "2 години",
      "valid-until-quick-hint-3-months": "3 месеца",
      "valid-until-quick-hint-6-months": "6 месеца"
    },
    "location": "Обект",
    "never-expires": "Безсрочен",
    "no-locations": "Нямате достъп до органайзера на нито един обект",
    "no-reminder-label": "Без напомняне",
    "notify-before-expiry-label": "Напомняне <ReminderDuration/> по-рано",
    "state": {
      "complete": "Завършен",
      "pending": "В изчакване"
    },
    "title": "Органайзер",
    "valid-from": "Валиден от <2><0></0></2> <4></4>",
    "valid-from-until": "Валиден от <2><0></0></2> до <6><0></0></6>",
    "valid-until": "Валиден до <2><0></0></2> ",
    "validity": {
      "expired": "Изтекъл",
      "expires-soon": "Изтича скоро"
    }
  },
  "player": {
    "lesson-duration": "{{minutes}} минути",
    "modal": {
      "again": {
        "header": "Темата завърши",
        "sub-header": "Изберете една от следните опции:",
        "watch-again": "Гледай отново"
      },
      "current": {
        "continue-button": "Продължи",
        "continue-header": "За да продължите, натиснете \"Продължи\"",
        "ended-header": "Вие приключихте с тази тема",
        "go-to-test": "Преминете към теста"
      },
      "segment": {
        "back-to-home": "Към началния екран",
        "back-to-results": "Обратно към резултатите",
        "header": "Този сегмент съдържаше отговорът на въпроса",
        "sub-header": "Изберете една от следните опции",
        "watch-again": "Гледай отново"
      }
    },
    "remaining-time-minutes": "Остават {{minutes}} минути.",
    "remaining-time-seconds": "Остават {{seconds}} секунди.",
    "watch-lesson": "Гледай темата"
  },
  "purchase-doc": {
    "disclaimer": "Възможни са несъответствия, сравнете с оригиналните документи.",
    "field": {
      "address": "Адрес",
      "eik": "ЕИК",
      "expiration-date": "Срок",
      "item-number": "Код",
      "lot-number": "Партида",
      "mol": "МОЛ",
      "name": "Наименование",
      "quantity": "Количество",
      "quantity-short": "Кол.",
      "total-price": "Сума",
      "unit": "Единица",
      "unit-price": "Единична цена",
      "unit-price-short": "Ед. цена",
      "unit-short": "Ед."
    },
    "party": {
      "buyer": "Купувач",
      "supplier": "Продавач"
    },
    "print-title": "Документ №{{number}}",
    "products": "Продукти",
    "totals": {
      "base": "Основа",
      "total": "Общо",
      "vat": "ДДС"
    }
  },
  "syllabus": {
    "completed": {
      "completed-at": "Завършено на <2><0></0></2> със среден успех <5>{{scorePercent}}</5>",
      "completed-course": "Поздравления за успешно завършено обучение!",
      "no-completed": "Няма завършени обучения",
      "no-such-topic": "Няма такъв изминал урок",
      "sign-button": "Подпис за протокола",
      "sign-button-again": "Нов подпис",
      "title": "Завършени обучения"
    },
    "in-progress": {
      "course-progress": "Завършени {{completedLessonsCount}} от {{totalLessonsCount}} урока ({{progressPercent}}) със среден успех {{averageScorePercent}}",
      "current-test-progress": "Текущ резултат от теста {{currentScorePercent}} при мин. {{minScorePercent}}.",
      "days-remaining": "{{days}} дни до крайния срок",
      "from-induction-course": "От встъпително обучение",
      "from-refresh-course": "От опреснително обучение",
      "induction-course": "Встъпително",
      "last-answered-at": "Последният отговор е даден на <1></1>",
      "no-in-progress-topic": "Няма текуща тема",
      "overdue": "Просрочено с {{days}} дни!",
      "refresh-course": "Опреснително",
      "test-progress": "Тестът не е предаден. Отговорени {{totalEmployeeAnswers}} от {{totalCorrectAnswers}} въпроса.",
      "there-is-important-question": "Има сбъркан задължителен въпрос",
      "title": "Текуща тема"
    },
    "pending": {
      "locked": "Все още е недостъпна. Имате незавършена текуща тема",
      "no-pending-course": "Няма текущо обучение",
      "title": "Текущо обучение"
    },
    "term-signature": {
      "title": "Подпишете се за протокола, че сте преминали това обучение"
    },
    "topic": {
      "completed-at": "Завършена на <1></1> с успех {{scorePercent}}.",
      "started-at": "Започната на <1></1>."
    }
  },
  "test": {
    "cant-view-test": "Тестът е достъпен, когато приключите текущата тема",
    "cant-view-test-result": "Резултатът от теста е достъпен, когато приключите текущата тема",
    "check-the-answer-in-segment": "Виж отговора в откъс от темата",
    "complete-test": "Предай теста",
    "congrats": "Поздравления!",
    "continue-to-next": "Продължете към следващата тема",
    "correct-answer": "Верен отговор",
    "failed-answers-paragraph": "Имате {{questionsCount}} грешни отговора на следните въпроси:",
    "next-question": "Следващ",
    "no-answer": "Няма отговор",
    "no-test-message": "Към тази тема няма тест",
    "not-sufficient-title": "Той не е достатъчен за да преминете към следващата тема.",
    "prev-question": "Предишен",
    "question-no": "Въпрос № {{questionNo}}",
    "refresh-the-answer-in-segment": "Припомни си отговора в откъс от темата",
    "result-title": "Резултат от теста",
    "success-rate": "Вие успешно решихте теста с {{currentScorePercent}}% успеваемост",
    "take-test": "Решете теста",
    "take-test-again": "Решете сгрешените въпроси отново",
    "take-test-again-hint": "За да решите теста отново трябва да изгледате всички откъси от темата, на които сте дали грешен отговор.",
    "title": "Тест към текущата тема",
    "view-results": "Вижте резултата от теста",
    "wrong-questions-title": "Имате {{questionsCount}} грешни отговора, ето и верните отговори:",
    "your-answer": "Вашият отговор",
    "your-result-is": "Вашият резултат е {{currentScorePercent}}%"
  },
  "ticket": {
    "action": {
      "accept": "Приеми",
      "done": "Приключи",
      "print": "Печат",
      "todo": "За изпълнение"
    },
    "add": {
      "content": "Описание",
      "content-placeholder": "Добавете подробности, които биха помогнали за решението на сигнала",
      "group-employees": "Служители",
      "group-managers": "Управители",
      "location": "За обекти",
      "location-placeholder": "За кои обекти се отнася сигнала, ако е приложимо",
      "recipients-label": "Получатели",
      "recipients-required": "Моля, изберете поне един получател",
      "recipients-search-placeholder": "Търсене по име, длъжност или обект",
      "subject": "Относно",
      "subject-placeholder": "За какво се отнася сигнала",
      "submit": "Създай",
      "title": "Нов сигнал"
    },
    "change-status": "Промяна на статус",
    "create-from-cc": "Подай сигнал",
    "delete": {
      "confirm-message": "Сигурни ли сте, че искате да изтриете този сигнал?",
      "confirm-title": "Изтриване на сигнал"
    },
    "detail": {
      "control-card": "<Name/> от <Date/>",
      "message-placeholder": "Напишете съобщение...",
      "refreshed": "Сигналът е обновен",
      "status-changed": "<Name/> промени статуса на <Status/>",
      "title": "Сигнал"
    },
    "edit": {
      "submit": "Запази"
    },
    "filter": {
      "location": "За обекти",
      "no-location": "Без обект",
      "status": "Статус",
      "text": "Търсене",
      "text-placeholder": "Търсене в сигнали...",
      "title": "Филтър"
    },
    "new": "Нов сигнал",
    "no-tickets": "Няма намерени сигнали",
    "pagination-count": "{{itemCount}} сигнала",
    "status": {
      "DONE": "Приключен",
      "IN_PROGRESS": "Изпълнява се",
      "TODO": "За изпълнение"
    },
    "tab": {
      "for-me": "За мен",
      "from-me": "От мен"
    },
    "title": "Сигнали"
  }
}
